import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { dashboardCompanyOverviewUrl, WORKBOARD_CURRENT_VALUATIONS_URL } from 'dashboard409a/common/config/urls';
import { COMPANY_DETAILS_SLUGS, WORKBOARD, WORKBOARD_SLUG } from 'dashboard409a/common/constants';
import { RootStateType } from 'dashboard409a/states/store';
import { BreadcrumbLink, BreadcrumbText, StyledBreadcrumbs, StyledSkeleton } from './styles';
import { IBreadcrumb } from './types';

const Breadcrumb: FC<IBreadcrumb> = props => {
  const { navigationItems, currentSlug } = props;
  const location = useLocation();

  const { currentCompany } = useSelector((state: RootStateType) => state.global);
  const isWorkboard = location.pathname.includes(`/${WORKBOARD_SLUG}/`);

  if (!currentCompany && !isWorkboard) {
    return <StyledSkeleton variant="text" width={200} height={22} />;
  }

  return (
    <StyledBreadcrumbs>
      { currentCompany && !isWorkboard && (
        <Link to={dashboardCompanyOverviewUrl(currentCompany?.slug)}>
          <BreadcrumbLink>409A Dashboard</BreadcrumbLink>
        </Link>
      )}

      {isWorkboard && (
        <Link to={WORKBOARD_CURRENT_VALUATIONS_URL}>
          <BreadcrumbLink>{WORKBOARD}</BreadcrumbLink>
        </Link>
      )}

      {COMPANY_DETAILS_SLUGS.includes(currentSlug) ? (
        <BreadcrumbText>Company Settings</BreadcrumbText>
      ) : !isWorkboard && (
        <BreadcrumbText>Reports</BreadcrumbText>
      )}

      {navigationItems.length > 0 && (
        <BreadcrumbText>{navigationItems.find(item => item.id === currentSlug)?.title}</BreadcrumbText>
      )}
    </StyledBreadcrumbs>
  );
};

export default Breadcrumb;
